import { SvgProps } from './types'

export const MoneyPieChartIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_3512_16851)">
        <path
          d="M26.9736 20.274C26.9736 24.4038 23.6329 27.7544 19.5152 27.7544C15.3975 27.7544 12.0608 24.4038 12.0608 20.274C12.0608 16.1442 15.3975 12.7976 19.5152 12.7976C23.6329 12.7976 26.9736 16.1481 26.9736 20.274Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.5859 8.3396C24.055 8.76682 26.2676 9.9496 27.9834 11.6348"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.39925 24.57C4.99301 23.2211 4.77213 21.7891 4.76819 20.3057"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.09881 30.741C8.49536 30.1397 7.94712 29.4831 7.4541 28.7869"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.4541 20.3057V20.2741C7.4541 14.3128 11.7572 9.35618 17.421 8.36329M28.5593 34.6414C25.9443 36.3029 22.8402 37.2641 19.5153 37.2641H19.5035C14.8376 37.2641 10.6094 35.3653 7.5527 32.2996M31.4148 8.19714C31.4424 8.22483 31.474 8.25252 31.5016 8.28021C34.5623 11.3538 36.4555 15.5944 36.4555 20.278C36.4555 24.4553 34.9527 28.2806 32.4561 31.2395"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.55261 32.2957L14.1315 25.6935"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.83118 20.3057H12.0648"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.2513 23.2608C17.6852 23.8304 18.4504 24.2102 19.326 24.2102C20.6788 24.2102 21.7792 23.2964 21.7792 22.169C21.7792 20.8834 20.5723 20.3493 19.5035 20.1357C18.549 19.9458 17.5077 19.4197 17.5077 18.2923C17.5077 17.2678 18.5056 16.441 19.7362 16.441C20.5171 16.441 21.2034 16.7773 21.6017 17.2797"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5153 25.6262V24.2021"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5153 14.922V16.4291"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.7097 14.914L31.4108 8.19312"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0623 28.9926L32.9254 36.6746H35.8914"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.5773 37.0901C39.8059 36.1184 39.2059 35.1448 38.237 34.9154C37.2682 34.6861 36.2974 35.2879 36.0687 36.2596C35.84 37.2313 36.4401 38.205 37.4089 38.4343C38.3778 38.6637 39.3486 38.0618 39.5773 37.0901Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.82363 37.7217C5.52754 37.0157 5.52754 35.871 4.82363 35.1651C4.11972 34.4591 2.97846 34.4591 2.27454 35.1651C1.57063 35.871 1.57063 37.0157 2.27454 37.7217C2.97846 38.4276 4.11972 38.4276 4.82363 37.7217Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.2408 5.03221C27.1605 4.65013 27.5972 3.59264 27.2162 2.67022C26.8353 1.74781 25.7809 1.30978 24.8612 1.69186C23.9415 2.07393 23.5047 3.13143 23.8857 4.05384C24.2667 4.97625 25.321 5.41428 26.2408 5.03221Z"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5034 10.4203V4.83873L23.7473 3.67969"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.55263 25.6262L3.54932 29.6413V34.4871"
          stroke={drawColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
